var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRaiseHand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "icon",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.8814 11C26.8814 9.14348 26.1439 7.36301 24.8312 6.05025C23.5184 4.7375 21.738 4 19.8814 4",
    stroke: "currentColor",
    strokeOpacity: 0.7,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.99553 20.2111L9.09897 13.36C9.12883 13.0335 9.27768 12.7294 9.51718 12.5056C9.74723 12.2859 10.0547 12.1659 10.3728 12.1717C10.5228 12.1797 10.6695 12.2186 10.8037 12.2861C10.9379 12.3535 11.0568 12.448 11.1527 12.5636C11.2486 12.6791 11.3196 12.8133 11.3612 12.9577C11.4028 13.102 11.4141 13.2534 11.3943 13.4023L11.3809 15.9615",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4858 16.1109L15.9334 7.46546C16.0191 7.32068 16.1325 7.19421 16.2671 7.09325C16.4017 6.9923 16.5548 6.91884 16.7178 6.87707C16.8808 6.83531 17.0504 6.82606 17.2169 6.84984C17.3835 6.87363 17.5437 6.92999 17.6884 7.0157C17.8351 7.09821 17.964 7.2088 18.0679 7.34114C18.1717 7.47348 18.2485 7.62498 18.2938 7.787C18.3391 7.94902 18.3521 8.11838 18.332 8.2854C18.3118 8.45243 18.259 8.61385 18.1764 8.76046L15.8508 13.7305L19.3339 8.69776C19.5204 8.43157 19.8 8.24494 20.1173 8.17466C20.4347 8.10438 20.7669 8.15554 21.0484 8.31808C21.3299 8.48061 21.5403 8.74271 21.6381 9.0527C21.736 9.3627 21.7141 9.69809 21.5769 9.99276L17.7774 15.5737L21.5059 11.4136C21.6925 11.1475 21.972 10.9608 22.2894 10.8905C22.6068 10.8203 22.939 10.8714 23.2205 11.034C23.502 11.1965 23.7124 11.4586 23.8102 11.7686C23.908 12.0786 23.8862 12.414 23.7489 12.7086L19.7056 17.4179L21.8249 15.3991C22.3934 14.9964 22.9633 14.5934 23.5799 14.9494C24.1965 15.3054 24.5417 16.1975 24.0679 16.6941L20.8401 20.6329L18.805 22.9798C17.2135 24.8483 14.2601 25.3637 12.7091 24.4682C11.9988 24.0817 11.3151 23.6484 10.6624 23.1711C10.18 22.8955 9.77538 22.5021 9.4863 22.0277C9.19723 21.5532 9.03317 21.0132 9.00945 20.4582",
    stroke: "currentColor",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRaiseHand);
export default __webpack_public_path__ + "static/media/raise-hand.c5babfcd96843f5883584e583a8ef0f7.svg";
export { ForwardRef as ReactComponent };